<template>
  <div>
    <div id="downgradeTeamsPopupId" class="modal custom" role="dialog">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header no-border">
            <div class="close-btn col-xs-12 text-right p-0">
              <img @click="closeConfirmPopup" class="cursor-pointer" src="/static/images/icons/ul_close_icon.svg" />
            </div>
          </div>
          <div class="modal-body p-0 row m-0">
            <div>
            <p class="confirm_title">
                {{ $t('downgradeTeamWarnInfo') }}
            </p>
            <p class="confirm-delete">{{ $t('DoYouWantToDowngrade') }}</p>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-xs-12 p-0 d-flex justify-content-end col-gap-16">
            <button type="button" class="btn emergo-btn emergo-secondary-button" :class="getLanguage()?'w-210':''" @click="closeConfirmPopup">
          {{ $t('noCancel')}}
            </button>
            <button
              type="button"
              class="btn emergo-btn emergo-primary-button"
              @click="navigateToTeams()"
            >{{ $t('yesProceed')}}</button>
          </div>
          </div>
          <!-- <loader :loadingStatus="downgradeWarnInfo.loaderStatus"></loader> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';
// import Loader from './Loader.vue';

export default {
  data() {
    return {
      deleteInfo: null,
    };
  },
  components: {
    // Loader,
  },
  props: ['userSelectedValue'],
  methods: {
    navigateToTeams() {
      this.closeConfirmPopup();
      EventBus.$emit('openTeams', this.userSelectedValue);
    },
    closeConfirmPopup() {
      $('#downgradeTeamsPopupId').modal('hide');
    },
    getLanguage() {
      return this.$i18n.locale === 'Portuguese';
    },
  },
};
</script>

<style scoped>
.delete-team-member {
  color: #333333;
}
.custom .modal-content{
  background: #FFFFFF;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px !important;
}
.custom .modal-header{
    padding: 0px !important;
    background-color: #fff !important;
    border-bottom: none;
}
.custom .modal-header .close-btn{
  position: relative;
  top: 15px;
  right: 15px;
}
.custom .modal-body{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-top: 5px;
}
.custom .modal-body .confirm_title{
  margin-bottom: 20px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.custom .modal-body .delete-warn{
  margin-bottom: 24px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.custom .modal-body .confirm-delete{
  margin-bottom: 34px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}
.blue_outline_cancel_button{
  background-color: #fff;
  border: 1px solid #000000;
  height: 44px;
  max-width: 184px;
  border-radius: 5px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
  padding: 10px 43px;
}
.blue_filled_Proceed_button{
  background-color: #01518A;
    border: 1px solid #01518A;
    height: 44px;
    cursor: pointer;
    min-width: 217px;
    border-radius: 5px;
    margin-top: 0px !important;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    color:#ffffff;
    line-height: 25px;
    padding: 10px 53px;
}
.w-210 {
  max-width:210px
}
.mb-20 {
  margin-bottom: 20px;
}

p {
  margin-bottom: 0px;
}
.mr-16{
  margin-right: 16px;
}
.modal-footer .btn {
  width: 160px;
}

.mb-40{
  margin-bottom: 40px;
}

/* .cancel-span{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
} */

.delete {
  background: #4C9E45;
  border: 1px solid #4C9E45;
  box-sizing: border-box;
  border-radius: 20px;
  height: 36px;
  width: 160px;
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
}

.delete-span{
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #F2F2F2;
}

.custom .modal-header {
  padding-left: 30px;
  border-bottom: 0 none;
  background-color : white;
  padding-right: 10px;
  padding-bottom: 0;
}

.modal-body {
  padding: 16px 28px 0px 20px;
}

.doc_name {
  font-size: 14px;
  font-weight: 400;
}
.custom .modal-footer {
  margin-top: 10px;
  padding-left: 16px;
  padding-right: 16px;
  background-color: #fafaf9;
  border-top: none;
  border-radius: 8px;
  max-height: 76px;
  display: flex;
}
.confirm_title{
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  word-break: break-word;
}

.modal-content{
  border-radius: 10px !important;
}

.modal-dialog{
  max-width: 600px;
}

.text-start {
  text-align: start;
}

.mb-30 {
  margin-bottom: 30px;
}

ul {
  max-height: 150px;
  overflow: auto;
  scrollbar-width: thin;
}

::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px black;
  background-color: white;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: darkgray;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: gray;
}

@media screen and (max-width: 767px) {
  .xs-mb-10 {
    margin-bottom: 10px;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (min-width: 768px){
  .modal-footer .cancel{
    margin-right: 16px;
  }
}
</style>
